import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import {Track} from '@app/web-player/tracks/track';
import {isIOSOrAndroid} from '@common/core/platform-detection';
import {StackTrigger} from '@ui/overlays/stack-navigator/stack-trigger';
import {TrackPage} from './track-page';
import {getTrackLink} from './track-href';

interface TrackLinkProps extends Omit<LinkProps, 'to'> {
  track: Track;
  className?: string;
  closePlayerOverlayOnOpen?: boolean;
}
export function TrackLink({
  track,
  className,
  closePlayerOverlayOnOpen = false,
  ...linkProps
}: TrackLinkProps) {
  const finalUri = useMemo(() => {
    return getTrackLink(track);
  }, [track]);

  if (!isIOSOrAndroid()) {
    return (
      <Link
        {...linkProps}
        className={clsx(
          'overflow-x-hidden overflow-ellipsis hover:underline',
          className,
        )}
        to={finalUri}
      >
        {track.name}
      </Link>
    );
  }

  return (
    <StackTrigger
      moveFocusToDialog={false}
      title={track.name}
      closePlayerOverlayOnOpen={closePlayerOverlayOnOpen}
    >
      <div
        className={clsx(
          'overflow-x-hidden overflow-ellipsis hover:underline',
          className,
        )}
      >
        {track.name}
      </div>
      <TrackPage track={track} />
    </StackTrigger>
  );
}

export {getTrackLink} from './track-href';
